// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".md-field[data-v-277d8f40]{border-radius:5px}.change-request[data-v-277d8f40]{padding:1em}.btn-close[data-v-277d8f40]{position:relative;right:-12em;top:-.2em;width:.5em!important}.btn-close[data-v-277d8f40],.btn-request[data-v-277d8f40]{background-color:#fff;float:right!important}.btn-request[data-v-277d8f40]{top:-.5em}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
